import React, { useState, useEffect } from 'react'

import IconButton from 'components/elements/IconButton'

// css
import 'assets/style/elements/date-guide.scss'

function Element({ text, className, type = 'box', nextClick = () => {}, prevClick = () => {} }) {
  return (
    <>
      <div className={`date-guide mt8 ${className}`}>
        <IconButton size="30" className="prev-arrow-btn" onClick={nextClick} />
        <strong>{text}</strong>
        <IconButton size="30" className="next-arrow-btn" onClick={prevClick} />
        <span />
      </div>
    </>
  )
}

export default Element
